import script from "./EnrollReviewManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./EnrollReviewManagement.vue?vue&type=script&setup=true&lang=js"

import "./EnrollReviewManagement.vue?vue&type=style&index=0&id=768e35fa&scoped=true&lang=css"

import exportComponent from "/Users/lidonglei/Documents/project/Dean_DHSES/dean_dhses_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-768e35fa"]])

export default __exports__